import type { Timestamp } from '@principle-theorem/shared';

export type OvieHealthAnalyticsSyncStatus = 'success' | 'failure' | 'never';

/**
 * Sync metadata for the AI Receptionist analytics integration.
 * Tracks when data was last fetched from the Ovie API and whether it succeeded.
 *
 * The feature-level `enabled` toggle lives on IPracticeSettings.aiReceptionist.
 * Credentials (apiKey, baseUrl) live in environment.ts, NOT here.
 */
export interface IAIReceptionistAnalyticsConfig {
  lastSyncAt?: Timestamp;
  lastSyncStatus?: OvieHealthAnalyticsSyncStatus;
}
